import {
  ChannelkartNetworkGet,
  ChannelkartNetworkPut,
} from "../../services/networkService";
import { AttendanceRecord, RequestBody } from "./attendanceCorrectionTypes";
const getLoggedInUserId = () => {
  return (
    JSON.parse(localStorage.getItem("authContext") ?? "{}")?.user?.loginId || ""
  );
};
export const getRequestBody = (
  userAttendanceInfo: AttendanceRecord,
  message: string
): RequestBody => {
  return {
    status: "Rejected",
    description: message || "",
    referenceNumber: userAttendanceInfo?.referenceNumber ?? "",
    approvedBy: userAttendanceInfo?.approvedBy ?? "",
  };
};
export const filterAttendanceData = (
  usersAttendance: AttendanceRecord[]
): AttendanceRecord[] => {
  const loggedInUser = getLoggedInUserId(); // Get logged-in user from local storage
  const today = new Date(); // Get today's date
  const formattedToday = today.toISOString().split("T")[0]; // Format: 'YYYY-MM-DD'

  // Filter the attendance data
  return usersAttendance.filter((userAttendance) => {
    if (!userAttendance) return false; // Check if userAttendance is null or undefined

    // Check if not the logged-in user
    const isNotLoggedInUser =
      userAttendance?.loginId?.toLowerCase() !== loggedInUser?.toLowerCase();

    // Only show today's attendance
    const attendanceDate = userAttendance?.creationTime?.split(" ")?.[0]; // Get date part
    const isToday = attendanceDate === formattedToday;

    // Exclude rejected attendance records
    const isNotRejected = userAttendance?.status?.toLowerCase() !== "rejected";

    // Combine all conditions
    return isNotLoggedInUser && isToday && isNotRejected;
  });
};
// API calls
export const fetchAttendanceData = async () => {
  try {
    const loggedInUser = getLoggedInUserId();
    if (!loggedInUser) {
      throw new Error("Logged in user not found");
    }
    const today = new Date();
    const formattedToday = today.toISOString().split("T")[0];
    const api = `/attendance?size=1000&filter=hierarchy[match]:${loggedInUser} and startTime[gte]:${formattedToday}T00:00:00`;
    const response = await ChannelkartNetworkGet(api);
    if (response?.status === 200) {
      return response?.data?.features ?? [];
    } else {
      throw new Error("Error in fetching data");
    }
  } catch (error) {
    throw new Error("Error in fetching data");
  }
};

export const putRejectAttendanceRequest = async (requestBody: RequestBody) => {
  try {
    const refNo = requestBody?.referenceNumber; // Extract reference number from requestBody
    if (!refNo) {
      throw new Error("Reference number not found in request body");
    }

    const response = await ChannelkartNetworkPut(
      `/attendance/${refNo}`,
      requestBody,
      {
        featureName: "Attendance Correction",
        avoidLogs: true,
      }
    );

    if (response?.status === 201) {
      return true;
    } else {
      return false;
    }
  } catch (error) {
    throw new Error("Error in rejecting attendance");
  }
};
